// The highest UOS panel and SSR index the switches actually reference.
//
// Two callers need this and must agree: derivePanelCounts raises a stored count
// to what the switches prove when loading a location, and collectConfirmProblems
// refuses to confirm when a stored count is below it. If the two computed the
// maximum differently, the form would repair a site on the way in and then
// reject it on the way out.
const highest = (values) =>
  values.reduce((max, value) => {
    const n = Number(value);
    return Number.isFinite(n) && n > max ? n : max;
  }, 0);

const asList = (switches) => (Array.isArray(switches) ? switches : []);

// UOS is stored zero-padded on the switch ('01', '02'), so Number() is what
// turns it back into a panel number.
export const highestAssignedUOS = (switches) =>
  highest(asList(switches).map((each) => each?.UOS));

// selectedSSR is a list of single-key objects — [{ ssr1: {...} }, { ssr4: {...} }]
// — so the index lives in the key name.
export const highestAssignedSSR = (switches) =>
  highest(
    asList(switches).flatMap((each) =>
      (Array.isArray(each?.selectedSSR) ? each.selectedSSR : []).flatMap(
        (entry) => Object.keys(entry ?? {}).map((key) => key.replace('ssr', '')),
      ),
    ),
  );
